import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './lang/i18n'
import './polyfills'

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import * as echarts from 'echarts';  
import { Buffer } from 'buffer';
window.Buffer = Buffer; // 将 Buffer 设为全局变量

const app = createApp(App);
app.config.globalProperties.$echarts = echarts;
app.use(Antd).use(store).use(router).use(i18n).mount('#app');
